// extracted by mini-css-extract-plugin
module.exports = {"fill-politico-red":"_1Ad6xoFg-JzU1YQXaNNeX1","styles":"mPl2HKXMDWutzSm6aOg4"};